const getters = {
    microAppsUrlParams(state) {
        return state.microAppsUrlParams;
    },
    marketplaceId(state) {
        return state.marketplaceId || JSON.parse(localStorage.getItem('mid'));
    },
    transactionId(state) {
        return state.transactionId || JSON.parse(localStorage.getItem('tid'));
    },
    gstDataQuery(state) {
        return state.gstDataQuery;
    },
    udyamDataPass(state) {
        return state.udyamDataPass;
    },
    videoKycScheduledDateTime(state) {
        return state.videoKycScheduledDateTime;
    },
    fssaiDataPass(state) {
        return state.fssaiDataPass;
    },
    fdaDataPass(state) {
        return state.fdaDataPass;
    },
    shopAndEstablishmentDataPass(state) {
        return state.shopAndEstablishmentDataPass;
    },
    otherDataPass(state) {
        return state.otherDataPass;
    }
};
export default getters;
